module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/RecommendationIcon.dd79fa14.svg";